__turbopack_context__.v({
  "fade-in": "RadioGroup-module-scss-module__SyWc6G__fade-in",
  "fauxRadio": "RadioGroup-module-scss-module__SyWc6G__fauxRadio",
  "label": "RadioGroup-module-scss-module__SyWc6G__label",
  "option": "RadioGroup-module-scss-module__SyWc6G__option",
  "options": "RadioGroup-module-scss-module__SyWc6G__options",
  "radio": "RadioGroup-module-scss-module__SyWc6G__radio",
  "root": "RadioGroup-module-scss-module__SyWc6G__root",
  "selected": "RadioGroup-module-scss-module__SyWc6G__selected",
});
